import React from 'react';
import Fade from 'react-reveal/Fade';
import * as ReactBootstrap from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Button, IconButton, Toolbar, Typography } from '@material-ui/core';
import {withRouter} from 'react-router-dom';
import AcUnitIcon from '@material-ui/icons/AcUnit';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
        color: 'black',
        flexGrow: 0.05,
        marginRight: theme.spacing(2),
    },
    span: {
        flexGrow: 1,
    }
  }));

function Navbar(props) {
    const classes = useStyles();
    return (
        <Fade top>
            <div>
                <AppBar position="static" style={{backgroundColor: 'white'}}>
                <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} aria-label="menu">
                        <AcUnitIcon/>
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        X-Meme
                    </Typography>
                    <span className={classes.span}></span>
                    <Button onClick={()=>props.changeFilter('All')} variant="h6" className={classes.title}>
                        All
                    </Button>
                    <Button onClick={()=>props.changeFilter('Coding')} variant="h6" className={classes.title}>
                        Coding
                    </Button>
                    <Button onClick={()=>props.changeFilter('Politics')} variant="h6" className={classes.title}>
                        Politics
                    </Button>
                    <Button onClick={()=>props.changeFilter('Sports')} variant="h6" className={classes.title}>
                        Sports
                    </Button>
                    <Button onClick={()=>props.changeFilter('Meme Lords')} variant="h6" className={classes.title}>
                        Meme Lord
                    </Button>
                    <Button onClick={()=>props.changeFilter('Misc')} variant="h6" className={classes.title}>
                        Misc
                    </Button>
                    <ReactBootstrap.Button onClick={()=>props.history.push('/')} variant="primary">Add New Meme</ReactBootstrap.Button>
                    </Toolbar>
                </AppBar>
            </div>
        </Fade>
    );
}

export default withRouter(Navbar);